var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkButton, UitkButtonSize } from 'uitk-react-button';
import { ClickTracker } from 'bernie-analytics';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
var ButtonTracked = ClickTracker(UitkButton);
// eslint-disable-next-line react/prefer-stateless-function
var HeaderSecondaryNavigationElementLink = /** @class */ (function (_super) {
    __extends(HeaderSecondaryNavigationElementLink, _super);
    function HeaderSecondaryNavigationElementLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSecondaryNavigationElementLink.prototype.render = function () {
        var secondaryElementData = this.props.secondaryElementData;
        var _a = this.props, showText = _a.showText, showIcon = _a.showIcon;
        showText = showText !== undefined ? showText : false;
        showIcon = showIcon !== undefined ? showIcon : false;
        var id = secondaryElementData.id, iconName = secondaryElementData.iconName, text = secondaryElementData.text, trackingEvent = secondaryElementData.trackingEvent, url = secondaryElementData.url, newWindow = secondaryElementData.newWindow;
        var snlId = id + "-button";
        var snlIconClass = id + "__icon";
        var ariaLabel = newWindow ? text + ". Opens in a new window." : text;
        if ((!showText || !text) && (!showIcon || !iconName)) {
            return null;
        }
        var buttonSize = showText && text ? UitkButtonSize.MEDIUM : UitkButtonSize.LARGE;
        var getChildren = function () {
            var children = [];
            if (showIcon && iconName) {
                children.push(React.createElement(UitkIcon, { name: iconName, size: UitkIconSize.MEDIUM, key: "icon-" + id }));
            }
            if (showText && text) {
                children.push(React.createElement(UitkText, { size: 300, key: "text-" + id }, text));
            }
            return children;
        };
        var element = (React.createElement(ButtonTracked, { size: buttonSize, id: id, rfrr: trackingEvent, href: url, linkName: id, "aria-label": ariaLabel, "data-stid": snlId, trackImmediate: true, target: newWindow ? '_blank' : '_self' }, getChildren()));
        if (showText && text) {
            return React.createElement("div", { className: snlIconClass, key: "div-" + id }, element);
        }
        return React.createElement("div", { className: snlIconClass, key: "div-" + id },
            React.createElement(UitkSpacing, { padding: { inline: 'three' } }, element));
    };
    return HeaderSecondaryNavigationElementLink;
}(React.Component));
export { HeaderSecondaryNavigationElementLink };
//# sourceMappingURL=header-secondary-navigation-element-link.js.map